import { useState } from "react";

/**
 * Product language (PRD §4.3): everyday terms everywhere, statistical terms only when "Show statistical detail" is on,
 * the same switch as in the app's sidebar.
 */
const TERMS: [string, string][] = [
	["Chance by date", "Cumulative probability (CDF)"],
	["When it happens", "Probability per period (PMF)"],
	["Low / Likely / High", "p10 / p50 / p90"],
	["If it happens: around Aug 2029", "Conditional median date"],
	["Assume", "Conditioning"],
	["Make it so", "Intervention, do()"],
	["What matters most", "Tornado sensitivity"],
	["What moved it", "Shapley attribution"],
	["Simulated futures", "Monte Carlo paths"],
];

export function PlainEnglish() {
	const [on, setOn] = useState(false);
	return (
		<section id="language" className="mx-auto max-w-[1240px] px-5 py-24 md:px-8 lg:py-32">
			<div className="grid gap-x-16 gap-y-12 lg:grid-cols-12">
				<div className="lg:col-span-5">
					<h2 className="text-[clamp(2.25rem,4.4vw,3.5rem)] leading-[1.02] tracking-[-0.035em]">Plain English, with the statistics one switch away.</h2>
					<p className="mt-6">
						A finance lead should not need a statistics course to read their own plan. An analyst should be able to audit the engine. ModelCurve speaks to the
						first by default and to the second on request.
					</p>
					<p className="mt-4 text-quiet">
						Every result is computed on the server from thousands of simulated futures. The same inputs and the same seed give the same answer, bit for bit.
						Chances are whole percentages, dates are months, and a forecast is always shown as the uncertain thing it is.
					</p>
				</div>

				<div className="lg:col-span-6 lg:col-start-7">
					<div className="flex items-center justify-between gap-4 rounded-t-md border border-line bg-white px-5 py-3.5">
						<span id="stat-label" className="text-sm font-medium text-ink">
							Show statistical detail
						</span>
						<button
							type="button"
							role="switch"
							aria-checked={on}
							aria-labelledby="stat-label"
							onClick={() => setOn((v) => !v)}
							className={`relative h-6 w-11 shrink-0 rounded-full transition-colors ${on ? "bg-peri-deep" : "bg-[#cfcad0]"}`}
						>
							<span className={`absolute top-0.5 left-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform ${on ? "translate-x-5" : ""}`} />
						</button>
					</div>
					<dl className="rounded-b-md border border-t-0 border-line bg-white">
						{TERMS.map(([plain, stat]) => (
							<div key={plain} className="grid items-baseline gap-x-4 gap-y-1 border-b border-line-soft px-5 py-3 last:border-b-0 sm:grid-cols-[1fr_auto]">
								<dt className="text-ink">{plain}</dt>
								<dd
									className={`font-mono sm:text-right text-[13px] text-quiet transition-[opacity,transform] duration-300 ${on ? "translate-x-0 opacity-100" : "translate-x-2 opacity-0 max-sm:hidden"}`}
									aria-hidden={!on}
								>
									{stat}
								</dd>
							</div>
						))}
					</dl>
				</div>
			</div>
		</section>
	);
}
